import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCheck } from 'react-icons/fa';



const Plan = ({ plan }) => {

  const { icon, image, title, price, features } = plan; // Extracting data from plan

  return (
    <div className="plan-item">

      <img src={image} alt={title} />

      <div className="content">

        <div className="intro">
          <h3><span>{plan.title.split(" ")[0]}</span> <br /> {plan.title.split(" ")[1]}</h3> {/* Plan Title */}
          <div className='top-icon'>{icon}</div> {/* Dynamic Icon */}
        </div>

        <div className='plan-info'>

          <div className='price'><span className="price">${price}</span>/ month</div> {/* Plan Price */}

          {/* List of Features */}
          <ul>
            {features.map((feature, index) => (
              <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
            ))}
          </ul>

          <Button link={"Car-Booking"} title={"Rent Now"} />

        </div>

      </div>

    </div>
  );
};

export default Plan;